import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/customer'

function* fetchCustomersRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchCustomers'))
  if (fe == null) {
    fe.size = 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_CUSTOMER,
    result,
  })
}

function* fetchCustomers({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchCustomers'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchCustomers', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_CUSTOMER,
    result,
  })
}

function* fetchCustomerEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_CUSTOMER,
    result,
  })
}

function* fetchCustomerSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_CUSTOMER_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_CUSTOMERS,
  })
}

function* fetchCustomerDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_CUSTOMER_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_CUSTOMERS,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_CUSTOMERS, fetchCustomers),
    takeEvery(actions.FETCH_CUSTOMER, fetchCustomerEdit),
    takeEvery(actions.SAVE_CUSTOMER, fetchCustomerSave),
    takeEvery(actions.DELETE_CUSTOMER, fetchCustomerDelete),
    takeEvery(actions.RE_FETCH_CUSTOMERS, fetchCustomersRefresh),
  ])
}
